import React, { useRef, useState, useEffect } from 'react'
import p5 from 'p5'
import { useWindowHeight, useWindowWidth } from '@react-hook/window-size'
import { isMobile } from 'react-device-detect'
import { useSelector, useDispatch } from 'react-redux'
import { PageWrapper } from './pageWrapper'
import { createPrefixOfResource, getLanguageInfo } from './../../common'
import { getFontSize, getFontClassName } from './../../styleFunctions'
import { InfoTextDiv } from './others'
import languages from './../../data/languages.json'
import localization from './../../data/localization.json'
import KiaSignatureLight from './../../fonts/KiaSignatureLight.ttf'

export const LoadingScreen = ({ cars = [], autoComplete = false, noLoading = false, middleFunction = () => { }, completeFunction = () => { }, realLoad = false }) => {
    const p5Ref = useRef(null)
    const windowHeight = useWindowHeight()
    const windowWidth = useWindowWidth()
    const language = useSelector(({ languageReducer }) => languageReducer.language)
    const firstLoad = useSelector(({ firstLoadReducer }) => firstLoadReducer)
    const dispatch = useDispatch()
    const [logoStyle, setLogoStyle] = useState(null)
    const [carIdx, setCarIdx] = useState(0)
    const [loadingTextPosition, setLoadingTextPosition] = useState(null)

    const getLoadingText = (language) => {
        if (language === null) {
            let lang_id = languages[0].id
            return localization["loading_txt_0"][lang_id]
        } else {
            return localization["loading_txt_0"][language]
        }
    }
    const sketch = (p) => {
        let logoImg = null

        let topMargin = 0
        let backHeight = 0

        let p5Languages = []
        let p5Cars = []
        let pinkOrGrey = true
        let pWindowWidth = null
        let pWindowHeight = null
        let slideTime = 0

        let p5CarIdx = 0

        let loadingPercent = noLoading ? 100 : 0
        // let kiaBold = null
        let kiaLight = null

        let completeFunctionCalled = false

        let willResourceLoad = true

        // let startDiv = null
        let languagePressed = false

        const calculateBackPosSize = () => {
            if (pWindowWidth / pWindowHeight > 360 / 640) {
                topMargin = 0
                backHeight = pWindowHeight
            } else {
                backHeight = pWindowWidth * 640 / 360
                topMargin = (pWindowHeight - backHeight) / 2
            }
        }

        // const calculateLeftPosition = () => {
        //     if (slideTime <= 30) {
        //         return (30 - slideTime) / 30 * pWindowWidth -1 / 4 * pWindowHeight
        //     } else if (slideTime <= 90) {
        //         return -1 / 4 * pWindowHeight
        //     } else {
        //         return (90 - slideTime) / 30 * pWindowWidth -1 / 4 * pWindowHeight
        //     }
        // }

        const calculateCarPosition = () => {
            if (slideTime <= 30) {
                return ((30 - slideTime) / 30 + 1 / 2) * pWindowWidth
            } else if (slideTime <= 90) {
                return pWindowWidth / 2
            } else {
                return ((90 - slideTime) / 30 + 1 / 2) * pWindowWidth
            }
        }

        p.setup = () => {
            let storageWindowWidth = window.localStorage.getItem('window_width')
            let storageWindowHeight = window.localStorage.getItem('window_height')
            if (storageWindowWidth === null || storageWindowHeight === null) {
                window.localStorage.setItem('window_width', p.windowWidth)
                window.localStorage.setItem('window_height', p.windowHeight)
                pWindowWidth = p.windowWidth
                pWindowHeight = p.windowHeight
            } else {
                pWindowWidth = storageWindowWidth
                pWindowHeight = storageWindowHeight
            }
            setLoadingTextPosition(pWindowHeight)
            p.createCanvas(pWindowWidth, pWindowHeight)
            // leftPosition = pWindowWidth

            p.frameRate(30)
        }

        p.preload = () => {
            p.loadImage(`${createPrefixOfResource()}/static/UI/img_kia_showroom_mark.png`, img => logoImg = img)
            if (!autoComplete) {
                if (languages.length < 2) {
                } else {
                    languages.forEach(lang => {
                        p5Languages.push({ id: lang.id, select: null, unselect: null })
                    })
                    languages.forEach((lang, idx) => {
                        p.loadImage(`${createPrefixOfResource()}${lang.selectSrc}`, img => p5Languages[idx].select = img)
                        p.loadImage(`${createPrefixOfResource()}${lang.unselectSrc}`, img => p5Languages[idx].unselect = img)
                    })
                }
            }
        }

        p.draw = () => {
            if (willResourceLoad) {
                cars.forEach((car) => {
                    p5Cars.push({ car: null, brand: null })
                })
                cars.forEach((car, idx) => {
                    p.loadImage(`${createPrefixOfResource()}${car.carSrc}`, img => p5Cars[idx].car = img)
                    // p.loadImage(`${createPrefixOfResource()}${car.brandSrc}`, img => p5Cars[idx].brand = img)
                    p5Cars[idx].brand = car.brandHTML
                })
                // p.loadFont(KiaSignatureBold, fnt => kiaBold = fnt)
                p.loadFont(KiaSignatureLight, fnt => kiaLight = fnt)

                willResourceLoad = false
                setTimeout(() => {
                    middleFunction()
                }, 2000)

            }

            const language = window.localStorage.getItem("lang_id")
            calculateBackPosSize()
            // cursor
            p.cursor('default')

            // draw background
            // if (pinkOrGrey) {
            //     p.background(155, 155, 155)
            //     p.fill(149, 22, 22)
            // } else {
            //     p.background(149, 22, 22)
            //     p.fill(155, 155, 155)
            // }
            // p.noStroke()
            // p.ellipse(calculateLeftPosition() + 1/4 * pWindowHeight, 1/2 * pWindowHeight, 1/2 * pWindowHeight, pWindowHeight * 1.2)
            // p.rect(calculateLeftPosition() + 1/4 * pWindowHeight, 0, pWindowWidth * 2, pWindowHeight)
            p.background(5, 20, 31)
            // draw car and brand            
            if (p5Cars[p5CarIdx].brand) {
                setLogoStyle({
                    left: calculateCarPosition() - pWindowWidth / 2,
                    right: pWindowWidth - calculateCarPosition() - pWindowWidth / 2,
                    top: topMargin + backHeight * 0.29 - (p5Languages.length > 2 ? (p5Languages.length - 2) * backHeight * 0.075 : backHeight * 0.075 * 0.7),
                    fontSize: backHeight * 0.043,
                })
            }
            if (p5Cars[p5CarIdx].car) {
                p.image(
                    p5Cars[p5CarIdx].car,
                    calculateCarPosition() - p5Cars[p5CarIdx].car.width * backHeight * 0.25 / p5Cars[p5CarIdx].car.height / 2,
                    topMargin + backHeight * 0.42 - (p5Languages.length > 2 ? (p5Languages.length - 2) * backHeight * 0.075 : backHeight * 0.075 * 0.7),
                    p5Cars[p5CarIdx].car.width * backHeight * 0.25 / p5Cars[p5CarIdx].car.height,
                    backHeight * 0.25
                )
            }
            // draw logo
            if (logoImg) {
                p.image(
                    logoImg,
                    pWindowWidth / 2 - logoImg.width * backHeight * 0.054 / logoImg.height / 2,
                    topMargin + backHeight * 0.05,
                    logoImg.width * backHeight * 0.054 / logoImg.height,
                    backHeight * 0.054
                )
                // if (kiaLight !== null)
                //     p.textFont(kiaLight)
                // p.noStroke()
                // p.fill(255, 255, 255)
                // p.textSize(backHeight * 0.03)
                // p.textAlign(p.CENTER, p.CENTER)
                // p.text(language !== null ? localization['loading_title_0'][language] : 'Virtual Experience', pWindowWidth / 2, topMargin + backHeight * 0.14)
            }
            // draw loading percent
            if (loadingPercent < 100) {
                p.strokeWeight(Math.max(backHeight / 200, 3))
                p.stroke(255, 255, 255, 70)
                p.noFill()
                p.circle(
                    pWindowWidth / 2,
                    topMargin + (backHeight * 0.81 - (p5Languages.length > 2 ? (p5Languages.length - 2) * backHeight * 0.075 : backHeight * 0.075 * 0.7)),
                    backHeight * 0.14
                )
                p.stroke(255, 255, 255)
                p.arc(
                    pWindowWidth / 2,
                    topMargin + (backHeight * 0.81 - (p5Languages.length > 2 ? (p5Languages.length - 2) * backHeight * 0.075 : backHeight * 0.075 * 0.7)),
                    backHeight * 0.14,
                    backHeight * 0.14,
                    -p.HALF_PI,
                    2 * p.PI * loadingPercent / 100 - p.HALF_PI
                )

                p.strokeWeight(1)
                p.stroke(255, 255, 255)
                p.fill(255, 255, 255)
                // if (kiaBold !== null)
                //     p.textFont(kiaBold)
                p.textSize(backHeight * 0.034)
                p.textAlign(p.CENTER, p.CENTER)
                p.text(
                    `${loadingPercent.toFixed(0)} %`,
                    pWindowWidth / 2,
                    topMargin + backHeight * 0.812 - (p5Languages.length > 2 ? (p5Languages.length - 2) * backHeight * 0.075 : backHeight * 0.075 * 0.7)
                )
            } else {
                let sceneLoaded = window.localStorage.getItem('sceneLoaded')
                if (autoComplete && (noLoading || !realLoad || sceneLoaded === 'yes') && !completeFunctionCalled) {
                    completeFunctionCalled = true
                    setTimeout(() => {
                        completeFunction(localStorage.getItem('lang_id'))
                    }, 250)
                    return
                }
                if (!autoComplete && (noLoading || !realLoad || sceneLoaded === 'yes')) {
                    if (languages.length < 2) {
                        // if (startDiv === null)
                        //     startDiv = p.createDiv(
                        //         `<div class="vrloadingReadyButton" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; color: #000; font-size: ${backHeight * 0.02}px" onclick="window.completeFunction()">${process.env.REACT_APP_HANDLER_TYPE === 'lhd' ? 'EMPEZAR' : 'START'}</div>`
                        //     )
                        // startDiv.addClass('kia-bold')
                        // startDiv.style(`width: ${backHeight * 0.14}px`)
                        // startDiv.style(`height: ${backHeight * 0.14}px`)
                        // startDiv.style(`background: white`)
                        // startDiv.style(`border-radius: ${backHeight * 0.07}px`)
                        // startDiv.style(`cursor: pointer`)
                        // startDiv.position(pWindowWidth / 2 - backHeight * 0.07, topMargin + (backHeight * 0.74 - (p5Languages.length > 2 ? (p5Languages.length - 2) * backHeight * 0.075 : backHeight * 0.075 * 0.7)))
                        if (!completeFunctionCalled) {
                            completeFunctionCalled = true
                            completeFunction(languages[0].id)
                        }
                    } else {
                        p5Languages.forEach((lang, idx) => {
                            if (lang.unselect && lang.select) {
                                if (lang.id === language) {
                                    p.image(
                                        lang.select,
                                        pWindowWidth / 2 - lang.unselect.width * backHeight * 0.067 / lang.unselect.height / 2,
                                        topMargin + (backHeight * 0.81 - (p5Languages.length > 2 ? (p5Languages.length - 2) * backHeight * 0.075 : backHeight * 0.075 * 0.7)) + (idx - p5Languages.length / 2) * backHeight * 0.075,
                                        lang.unselect.width * backHeight * 0.067 / lang.unselect.height,
                                        backHeight * 0.067
                                    )

                                } else {
                                    p.image(
                                        lang.unselect,
                                        pWindowWidth / 2 - lang.unselect.width * backHeight * 0.067 / lang.unselect.height / 2,
                                        topMargin + (backHeight * 0.81 - (p5Languages.length > 2 ? (p5Languages.length - 2) * backHeight * 0.075 : backHeight * 0.075 * 0.7)) + (idx - p5Languages.length / 2) * backHeight * 0.075,
                                        lang.unselect.width * backHeight * 0.067 / lang.unselect.height,
                                        backHeight * 0.067
                                    )

                                }
                                // cursor
                                if ((p.mouseX > pWindowWidth / 2 - lang.unselect.width * backHeight * 0.067 / lang.unselect.height / 2) && (p.mouseY > topMargin + (backHeight * 0.81 - (p5Languages.length > 2 ? (p5Languages.length - 2) * backHeight * 0.075 : backHeight * 0.075 * 0.7)) + (idx - p5Languages.length / 2) * backHeight * 0.075)) {
                                    if ((p.mouseX < pWindowWidth / 2 - lang.unselect.width * backHeight * 0.067 / lang.unselect.height / 2 + lang.unselect.width * backHeight * 0.067 / lang.unselect.height) && (p.mouseY < topMargin + (backHeight * 0.81 - (p5Languages.length > 2 ? (p5Languages.length - 2) * backHeight * 0.075 : backHeight * 0.075 * 0.7)) + (idx - p5Languages.length / 2) * backHeight * 0.075 + backHeight * 0.067)) {
                                        p.cursor('pointer')
                                    }
                                }
                            }
                        })
                    }
                }
            }
            // update parameters
            if (p5Cars.length === 1 && slideTime >= 30) {

            } else {
                slideTime++
            }

            if (slideTime >= 120) {
                slideTime = 0
                p5CarIdx = (p5CarIdx + 1) % p5Cars.length
                setCarIdx(p5CarIdx)
                pinkOrGrey = !pinkOrGrey
            }
            if (realLoad) {
                loadingPercent = Number(window.localStorage.getItem('engineLoadProgress')) * 100
            } else {
                if (loadingPercent < 100) {
                    loadingPercent += 1 + Math.random() * 2
                }
            }
        }

        p.windowResized = () => {
            pWindowWidth = p.windowWidth; pWindowHeight = p.windowHeight
            p.resizeCanvas(pWindowWidth, pWindowHeight + 360)
            setLoadingTextPosition(pWindowHeight)
        }

        p.mousePressed = () => {
            if (loadingPercent >= 100) {
                if (languages.length < 2) {
                    // let x0 = pWindowWidth / 2 - backHeight * 0.07; let x1 = pWindowWidth / 2 + backHeight * 0.07;
                    // let y0 = topMargin + backHeight * 0.74; let y1 = topMargin + backHeight * 0.88;
                    // if (x0 <= p.mouseX && p.mouseX <= x1) {
                    //     if (y0 <= p.mouseY && p.mouseY <= y1) {
                    //         completeFunction(languages[0].id)
                    //     }
                    // }
                    return
                } else {
                    if (!languagePressed) {
                        p5Languages.forEach((lang, idx) => {
                            if (lang.unselect && lang.select) {
                                let x0 = pWindowWidth / 2 - lang.unselect.width * backHeight * 0.067 / lang.unselect.height / 2
                                let y0 = topMargin + (backHeight * 0.81 - (p5Languages.length > 2 ? (p5Languages.length - 2) * backHeight * 0.075 : backHeight * 0.075 * 0.7)) + (idx - p5Languages.length / 2) * backHeight * 0.075
                                let x1 = x0 + lang.unselect.width * backHeight * 0.067 / lang.unselect.height
                                let y1 = y0 + backHeight * 0.067

                                if (x0 <= p.mouseX && p.mouseX < x1) {
                                    if (y0 <= p.mouseY && p.mouseY < y1) {
                                        languagePressed = true
                                        completeFunction(lang.id)
                                        return
                                    }
                                }
                            }
                        })
                    }
                    return
                }
            }
        }
    }

    useEffect(() => {
        window.completeFunction = () => completeFunction(languages[0].id)
        let myp5 = new p5(sketch, p5Ref.current)
        return () => {
            myp5.remove()
        }
    }, [])

    useEffect(() => {
        if (!firstLoad) {
            dispatch({ type: 'FIRST_LOADED' })
        }
    }, [dispatch, firstLoad])

    return (
        <PageWrapper carId={cars.length > 1 ? "default" : cars[0].id}>
            <div
                ref={p5Ref}
                style={{
                    position: 'fixed', zIndex: 100,
                    width: '100vw',
                    left: 0, top: 0, bottom: -360,
                    overflow: 'hidden',
                    backgroundColor: 'rgb(5, 20, 31)'
                }}
                className="vrloadingReadyButton"
            >
                {/* <P5Wrapper sketch={p => sketch(p)} /> */}
                <div id="p5_loading"></div>
            </div>
            {logoStyle === null ? null : <div
                style={{
                    ...logoStyle,
                    position: 'fixed',
                    zIndex: 101,
                    color: 'white',
                    textAlign: 'center',
                    verticalAlign: 'middle',
                    overflow: 'visible',
                }}
                className={getFontClassName('bold', language)}
                dangerouslySetInnerHTML={{ __html: cars[carIdx].brandHTML }}
            >

            </div>}
            <div
                className={getFontClassName('light', language)}
                style={{
                    position: 'fixed',
                    textAlign: 'center',
                    zIndex: 101,
                    fontSize: ((windowWidth / windowHeight > 360 / 640) ? windowHeight : windowWidth * 640 / 360) * 0.03,
                    left: 10, right: 10,
                    top: ((windowWidth / windowHeight > 360 / 640) ? windowHeight * 0.14 : (windowHeight - windowWidth * 640 / 360) / 2 + (windowWidth * 640 / 360) * 0.14),
                    color: '#fff'
                }}
            >
                {language !== null ? localization['loading_title_0'][language] : ''}
            </div>
            {isMobile ? (
                <>
                    {loadingTextPosition === null ? null : (
                        <div
                            className={getFontClassName('light', language)}
                            style={{
                                position: 'fixed',
                                left: 10,
                                right: 10,
                                // top: windowWidth / loadingTextPosition > 360 / 640 ? loadingTextPosition * 0.865 : ((windowWidth * 640 / 360) * 0.865 + (loadingTextPosition - windowWidth * 640 / 360) / 2),
                                bottom: windowWidth / loadingTextPosition > 360 / 640 ? loadingTextPosition * 0.025 : ((windowWidth * 640 / 360) * 0.025 + (loadingTextPosition - windowWidth * 640 / 360) / 2),
                                zIndex: 101,
                                color: 'white',
                                fontSize: getFontSize(windowHeight * 0.017, language),
                                textAlign: 'center',
                                verticalAlign: 'middle',
                                direction: getLanguageInfo(language).rtl ? 'rtl' : 'ltr'
                            }}>{getLoadingText(language)}</div>
                    )}
                </>
            ) : (
                <InfoTextDiv color="#ffffff" zIndex={105} />
            )}
        </PageWrapper>
    )
}